import { Box, Button, styled, TextField, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import {
  Body,
  ContentContainer as BaseContentContainer,
  PatientSummary as BasePatientSummary,
} from "@components";


export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: theme.palette.background.paper,
  },
  "& input": {
    minHeight: "32px",
    textAlign: "left",
    padding: "12px",
  },
}));

export const EmptyRequest = styled("p")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",
  padding: "72px 0px",
  color: theme.palette.text.secondary,
}));

export const SectionSubtitle = styled(Typography)({
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

export const SectionDisclaimer = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  color: theme.palette.text.secondary,
  paddingBottom: "16px",
}));

export const PrescriptionDetailsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  width: "100%",
});

export const MainActionButtonContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  padding: "8px 0px",
});

export const Footer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  paddingTop: "8px",
});

export const FlexSpacer = styled(Box)({
  flex: 1,
});

export const ContentContainer = styled(BaseContentContainer)(({ theme }) => ({
  gap: 24,
}));

export const PatientSummary = styled(BasePatientSummary)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const HeaderContainer = styled(Body)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%",
  paddingBottom: 0,
  justifyContent: "center",
  [theme.breakpoints.up("md")]: {
    justifyContent: "space-between",
    padding: 24,
    paddingBottom: 0,
    maxWidth: 1200,
  },
  [theme.breakpoints.down("md")]: {
    paddingBottom: 0,
  },
}));

export const Content = styled(Body)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  alignItems: "normal",
  [theme.breakpoints.up("md")]: {
    padding: 24,
    maxWidth: 1200,
    paddingTop: 0,
    paddingBottom: 0,
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 0,
  },
}));

export const PatientContent = styled(Box)(({ theme }) => ({
  width: "100%",
  [theme.breakpoints.up("md")]: {
    maxWidth: 328,
  },
}));

export const PrescriptionContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 16,
  width: "100%",
  paddingTop: 0,
  [theme.breakpoints.up("md")]: {
    maxWidth: "calc(min(850px,70%))",
  },
}));

export const PatientSummaryAccordionContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const AddMedicineButton = styled(Button)(({ theme }) => ({
  display: "flex",
  color: theme.palette.primary.dark,
  backgroundColor: theme.palette.primary.extralight,
  border: `1px solid ${theme.palette.primary.dark}`,
  borderRadius: "100px",
  width: "100%",
  textTransform: "none",
  "&:hover": {
    backgroundColor: theme.palette.primary.hover,
    border: `1px solid ${theme.palette.primary.dark}`,
  },
  [theme.breakpoints.up("md")]: {
    maxWidth: 240,
  },
}));

export const RouterLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export const SaveAsTemplateLabel = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 400,
  color: theme.palette.text.primary,
}));
